

<div class="container">
  <div #modelContainer class="configuration-panel" fxLayout="row" fxLayoutAlign="center center">
    <carousel *ngIf="images" [images]="images"></carousel>

    <div class="top-overlay" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-icon *ngIf="linkToPortal" class="link m-l-10 m-t-5" matTooltip="View in situPORTAL" aria-label="viewInPortal" 
        (click)="openInPortal()" matTooltipPosition="below" aria-hidden="false">
        exit_to_app
      </mat-icon>
    </div>

    <div class="homeconfig" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <a target="_blank" href="https://situsystems.com/"><img class="logo" src="https://cdn.situsystems.com/facade/2d7f08ea-ccdc-4c39-85ce-4e987ea79e65.png" alt="situSYSTEMS" matTooltip="situSYSTEMS"></a> 
    </div>
  </div>
</div>